import { CRYSTALLIZE_IDS } from "../../crystallize-constants.js";
import { getFreightRelationItems } from "../../shipping/selectors/getFreightRelationItems.js";
import { getSubscriptionType } from "./getSubscriptionType.js";
import { isSubscriptionShapeDigitalService } from "../../subscription-plan/selectors/isSubscriptionShape.js";
const SUBSCRIPTION_IDS = CRYSTALLIZE_IDS.SHAPE.PRODUCT.SUBSCRIPTION;
const SERIES_SUBSCRIPTION_IDS = CRYSTALLIZE_IDS.SHAPE.PRODUCT.SERIES_SUBSCRIPTION;
export const getSubscriptionVariantFreightOptions = (subscription) => {
    const subscriptionType = getSubscriptionType(subscription);
    if (isSubscriptionShapeDigitalService(subscriptionType)) {
        return { initial: [], recurring: [] };
    }
    const freightChunk = subscription.components?.find(({ componentId: id }) => id === SUBSCRIPTION_IDS.VARIANT.FREIGHT.ID ||
        id === SERIES_SUBSCRIPTION_IDS.VARIANT.FREIGHT.ID);
    if (freightChunk?.content?.__typename !== "ContentChunkContent")
        throw new Error(`Freight config is not of type content chunk - Sku ${subscription.sku}`);
    return freightChunk.content.chunks.flatMap((chunk) => {
        return chunk.reduce((acc, { componentId: id, content }) => {
            if ((id === SUBSCRIPTION_IDS.VARIANT.FREIGHT.INITIAL ||
                id === SERIES_SUBSCRIPTION_IDS.VARIANT.FREIGHT.INITIAL) &&
                content?.__typename === "ItemRelationsContent")
                return {
                    ...acc,
                    initial: getFreightRelationItems(content),
                };
            if ((id === SUBSCRIPTION_IDS.VARIANT.FREIGHT.RECURRING ||
                id === SERIES_SUBSCRIPTION_IDS.VARIANT.FREIGHT.RECURRING) &&
                content?.__typename === "ItemRelationsContent")
                return {
                    ...acc,
                    recurring: getFreightRelationItems(content),
                };
            return acc;
        }, {
            initial: [],
            recurring: [],
        });
    })[0];
};
